var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div data-test=\"followButton\" class=\"plus-follow-button\"><div class=\"icon-follow-circle\"></div><div class=\"follow-button-text\"></div></div>");;return buf.join("");
};
module.exports = template;